import React, { useEffect, useState } from 'react';
import Datepicker, { PopoverDirectionType } from 'react-tailwindcss-datepicker';
import RenderIf from '../Common/renderIf';
import './date-picker.scss';

export interface ShortcutsItem {
  text: string;
  daysNumber?: number;
  period: {
    start: Date | string;
    end: Date | string;
  };
}
export interface CustomRange {
  [key: string]: ShortcutsItem;
}
export type DateType = string | null | Date;
export interface DateValueType {
  startDate: DateType;
  endDate: DateType;
}
export interface DatePickerProps {
  label?: string;
  placeholder?: string;
  onChange: (from: Date | null, to: Date | null) => void;
  showShortcuts?: boolean;
  isOptional?: boolean;
  disabled?: boolean;
  minDate?: Date | null;
  maxDate?: Date | null;
  useSingleCalender?: boolean;
  showRange?: boolean;
  startTime?: Date | null;
  endTime?: Date | null;
  rangeStart?: Date | null;
  displayFormat?: string;
  popoverDirection?: PopoverDirectionType;
  hideLabel?: boolean;
}

const dateRangeConfig = {
  shortcuts: {
    today: 'Today',
    yesterday: 'Yesterday',
  },
};

const DatePicker: React.FC<DatePickerProps> = (props) => {
  const {
    onChange,
    label = 'Date',
    placeholder = 'Select Date',
    isOptional = true,
    startTime,
    endTime,
    minDate,
    maxDate,
    rangeStart,
    useSingleCalender = false,
    displayFormat = 'YYYY-MM-DD',
    showRange = false,
    showShortcuts = false,
    popoverDirection = 'down',
    hideLabel = false,
    disabled,
  } = props;

  const [value, setValue] = useState({
    startDate: startTime || null,
    endDate: endTime || null,
  });

  useEffect(() => {
    setValue({
      startDate: startTime || null,
      endDate: endTime || null,
    });
  }, [startTime, endTime]);

  const handleValueChange = (newValue: any) => {
    setValue(newValue);
    onChange(newValue.startDate, newValue.endDate);
  };

  return (
    <div className="date-range-picker">
      <RenderIf condition={!hideLabel}>
        <label className="text-base text-black font-light leading-normal">
          {!isOptional && <span className="text-mandatory">*</span>}
          {label}
        </label>
      </RenderIf>
      <Datepicker
        inputClassName="date-range-picker-input"
        toggleClassName="date-range-picker-toggle"
        placeholder={placeholder}
        popoverDirection={popoverDirection}
        separator={'to'}
        primaryColor={'teal'}
        value={value}
        onChange={handleValueChange}
        showShortcuts={showShortcuts}
        configs={dateRangeConfig}
        containerClassName="date-range-picker-container"
        dateLooking="middle"
        minDate={minDate}
        maxDate={maxDate}
        startFrom={rangeStart}
        asSingle={useSingleCalender}
        useRange={showRange}
        displayFormat={displayFormat}
        disabled={disabled}
      />
    </div>
  );
};

export default DatePicker;
